<template>
  <div>
    <div v-if="displayLoading">
      <Loading />
    </div>
    <div>
      <img
        v-if="getModuleConfig('page_kv_image')"
        :src="getModuleConfig('page_kv_image')"
        class="w-100"
      />
      <div class="page">
        <div
          v-if="getModuleConfig('verify_page.step_section.enable_step_section')"
          class="p-3"
        >
          <SharedStep
            :steps="getModuleConfig('verify_page.step_section.steps')"
          />
        </div>

        <div class="page__title">
          {{ getModuleConfig("verify_page.form_title") }}
        </div>
        <div
          class="page__desc"
          v-html="getModuleConfig('verify_page.form_desc')"
        ></div>

        <div class="form">
          <!-- fields -->
          <div
            v-for="(field, index) in fields.filter((x) => {
              return x.hidden == undefined || !x.hidden;
            })"
            :key="`field.${index}`"
            class="field"
          >
            <!-- mobile_phone -->
            <div v-if="field.type === 'mobile_phone'">
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ displayTitle(field, "手機號碼") }}</label
              >

              <div class="d-flex">
                <input
                  class="field__input flex-fill"
                  v-model="form.mobile_phone"
                  type="tel"
                  :class="{ invalid: v$.form.mobile_phone.$error }"
                  :placeholder="displayPlaceholder(field, '請輸入您的手機號碼')"
                  :disabled="
                    field.disabled || isMobileValidating || mobileIsValid
                  "
                  @keypress="v$.$touch()"
                />
                <SharedButton
                  v-if="getModuleConfig('verify_page.verify_phone')"
                  :disabled="
                    !form.mobile_phone ||
                    v$.form.mobile_phone.$error ||
                    isMobileValidating ||
                    mobileIsValid
                  "
                  class="ml-3 w-auto text-nowrap s-btn-bg-primary"
                  @click="sendMobile"
                >
                  <template v-if="isMobileValidating && counter > 0">
                    {{ counterMessage }}
                  </template>
                  <template v-else-if="mobileIsValid">{{ trans('mobile_verified', '已驗証') }}</template>
                  <template v-else> {{ trans('send_sms_code', '傳送驗證碼') }} </template></SharedButton
                >
                <button
                  v-if="
                    (!isMobileValidating &&
                      !mobileIsValid &&
                      user.phone_verified_at != null) ||
                    isMobileValidating
                  "
                  @click="
                    () => {
                      isMobileValidating = false;
                      mobileIsValid = user.phone_verified_at != null;
                      form.mobile_phone = user.mobile_phone;
                      codeValidMessage = null;
                    }
                  "
                  class="btn btn-link text-nowrap ml-3"
                >
                  {{ trans('cancel', '取消') }}
                </button>
                <button
                  v-if="mobileIsValid && !isMobileValidating"
                  @click="mobileIsValid = false"
                  class="btn btn-link text-nowrap ml-3"
                >
                  {{ trans('revise', '修改') }}
                </button>
              </div>
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div v-if="v$.form.mobile_phone.$error" class="form__error-msg">
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
              <div v-if="mobileValidMessage" class="form__error-msg">
                {{ mobileValidMessage }}
              </div>
              <div v-if="v$.mobileIsValid.$invalid" class="form__error-msg">
                {{ trans('not_verify_phone_number', '手機號碼未驗証') }}
              </div>

              <div v-if="isMobileValidating" class="code-input d-flex">
                <div class="flex-fill">
                  <CodeInput
                    :loading="false"
                    :fields="6"
                    class="google-sans-code"
                    :disabled="counter === 0"
                    :class="{ invalid: !codeIsValid }"
                    @change="(e) => (verificationCode = e)"
                  />
                  <div v-if="!codeIsValid" class="form__error-msg">
                    {{ codeValidMessage }}
                  </div>
                </div>
                <SharedButton
                  style="height: 54px"
                  class="ml-3 w-auto text-nowrap s-btn-bg-primary px-5"
                  :disabled="verificationCode.length != 6 || counter === 0"
                  @click="verifyMobile"
                >
                  {{ trans('confirm', '確定') }}
                </SharedButton>
              </div>
            </div>
            <!-- mobile_phone -->

            <!-- date -->
            <div v-else-if="field.type === 'date'">
              <label

                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <div
                class="field__select-group"
                :class="{
                  invalid:
                    v$.form[`${field.field_key}-year`].$error ||
                    v$.form[`${field.field_key}-month`].$error ||
                    v$.form[`${field.field_key}-day`].$error,
                }"
              >
                <SharedSelect
                  :id="`${field.field_key}-year`"
                  v-model="form[`${field.field_key}-year`]"
                  :options="yearOptions"
                  :hasBorder="false"
                  :placeholder="trans('years', '年份')"
                  :disabled="field.disabled"
                  :class="{ invalid: v$.form[`${field.field_key}-year`].$error }"
                />
                <SharedSelect
                  :id="`${field.field_key}-month`"
                  v-model="form[`${field.field_key}-month`]"
                  :options="monthOptions"
                  :hasBorder="false"
                  :placeholder="trans('months', '月份')"
                  :disabled="field.disabled"
                  :class="{ invalid: v$.form[`${field.field_key}-month`].$error }"
                />
                <SharedSelect
                  :id="`${field.field_key}-day`"
                  v-model="form[`${field.field_key}-day`]"
                  :options="
                    dayOptions(
                      form[`${field.field_key}-year`],
                      form[`${field.field_key}-month`]
                    )
                  "
                  :hasBorder="false"
                  :placeholder="trans('day', '日')"
                  :disabled="field.disabled"
                  :class="{ invalid: v$.form[`${field.field_key}-day`].$error }"
                />
              </div>
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="
                  v$.form[`${field.field_key}-year`].$error ||
                  v$.form[`${field.field_key}-month`].$error ||
                  v$.form[`${field.field_key}-day`].$error
                "
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- birthday -->

            <!-- address -->
            <div v-else-if="field.type === 'address'">
              <label

                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ displayTitle(field, "地址") }}</label
              >
              <div class="field__select-group mb-3 city-selector-set-has-value">
                <SharedSelect
                   :id="`${field.field_key}-city`"
                  v-model="form[`${field.field_key}-city`]"
                  :hasBorder="false"
                  selectClass="county"
                  :disabled="field.disabled"
                  :class="{ invalid: v$.form[`${field.field_key}-city`].$error }"
                />
                <SharedSelect
                :id="`${field.field_key}-district`"
                  v-model="form[`${field.field_key}-district`]"
                  :hasBorder="false"
                  selectClass="district"
                  :disabled="field.disabled"
                  :class="{ invalid: v$.form[`${field.field_key}-district`].$error }"
                />
              </div>
              <input
                :id="`${field.field_key}-address`"
                class="field__input"
                v-model="form[`${field.field_key}-address`]"
                :placeholder="displayPlaceholder(field, '請輸入詳細地址')"
                :disabled="field.disabled"
                :class="{
                  invalid:
                    v$.form[`${field.field_key}-address`].$error ||
                    v$.form[`${field.field_key}-district`].$error ||
                    v$.form[`${field.field_key}-city`].$error,
                }"
              />
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
            </div>
            <!-- email -->

            <!-- select type -->
            <div
              v-else-if="
                field.type === 'select' && field.matched_key && !field.provider
              "
            >
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <SharedSelect
                v-model="form[`${field.field_key}`]"
                :options="field.options"
                :hasBorder="false"
                :placeholder="displayPlaceholder(field)"
                :disabled="field.disabled"
                :class="{ invalid: v$.form[field.field_key].$error }"
              />
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="v$.form[field.field_key].$error"
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- select type -->

            <!-- branch type -->
            <div
              v-else-if="
                field.type === 'branch' && field.matched_key && field.provider
              "
            >
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <ShopSelection
                :ref="`shop-selection-${field.field_key}`"
                v-model="form[`${field.field_key}`]"
                :branch-provider="field.provider"
                :show-branch-code="!!field.show_branch_code"
                :placeholder="displayPlaceholder(field, '請選擇分店櫃點')"
              />
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="v$.form[`${field.field_key}`].$error"
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- branch type -->

            <!-- radio type -->
            <div v-else-if="field.type === 'radio' && field.matched_key">
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <div
                class="s-flex flex-wrap"
                :class="field.is_vertical && 'flex-column'"
              >
                <SharedRadioButton
                  v-for="(option, index) in field.options"
                  v-model="form[`${field.field_key}`]"
                  :id="field.title + index"
                  :key="field.title + index"
                  :value="option.value"
                  :name="field.matched_key"
                  :disabled="field.disabled"
                >
                  {{ option.text }}
                </SharedRadioButton>
              </div>
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="v$.form[`${field.field_key}`].$error"
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- radio type -->

            <!-- checkbox type -->
            <div v-else-if="field.type === 'checkbox' && field.matched_key">
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <div class="s-flex">
                <b-form-checkbox-group
                  :options="field.options"
                  v-model="form[`${field.field_key}`]"
                  :stacked="field.is_vertical"
                  :disabled="field.disabled"
                ></b-form-checkbox-group>
              </div>
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="v$.form[`${field.field_key}`].$error"
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- checkbox type -->

            <!-- text type -->
            <div v-else-if="field.matched_key">
              <label
                :id="field.field_key"
                class="field__label"
                :class="field.required === true ? 'field--required' : null"
                >{{ field.title }}</label
              >
              <input
                class="field__input"
                v-model="form[`${field.field_key}`]"
                :class="{ invalid: v$.form[field.field_key].$error }"
                :placeholder="displayPlaceholder(field)"
                :disabled="field.disabled"
                :type="field.type === 'email' ? 'email' : 'text'"
              />
              <small v-if="field.memo" class="field__desc">{{
                field.memo
              }}</small>
              <div
                v-if="v$.form[field.field_key].$error"
                class="form__error-msg"
              >
                {{ field.validate_error_message || validateErrorMessage }}
              </div>
            </div>
            <!-- text type -->
          </div>
          <!-- fields -->
        </div>
      </div>
      <div
        class="reminder"
        v-html="getModuleConfig('verify_page.reminder')"
      ></div>
      <div
        class="d-flex"
        v-if="
          getModuleConfig('verify_page.enable_terms_check') &&
          getModuleConfig('verify_page.terms_check')
        "
        style="margin-left: 12px"
      >
        <b-form-checkbox
          class="my-auto ml-2"
          v-model="termCheck"
        ></b-form-checkbox>
        <div
          class="terms_check"
          v-html="getModuleConfig('verify_page.terms_check')"
        ></div>
      </div>
      <div class="page__button">
        <SharedButton
          class="s-btn-bg-primary"
          @click="handleSubmit"
          :disabled="!termCheck"
        >
          {{ getModuleConfig("verify_page.button_text") || '送出' }}
        </SharedButton>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import SharedSelect from "@/components/Page/Liff/Shared/Select";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import SharedRadioButton from "@/components/Page/Liff/Shared/RadioButton";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import SharedStep from "@/components/Page/Liff/Shared/Steps";
import TwCitySelector from "tw-city-selector";
import registerApi from "@/apis/liff/v2/register";
import dateOptionMixin from "@/mixins/liff/dateOption";
import registerMixin from "@/mixins/liff/register";
import Loading from "@/components/Page/Liff/Shared/Loading";
import { isValidJsonArray } from "@/utils/jsonHelper";
import branchMixin from "@/mixins/Dashboard/branches";
import CodeInput from "@/components/CodeInput";

const TIMEOUT = 120;

export default {
  mixins: [dateOptionMixin, registerMixin, branchMixin],
  components: {
    CodeInput,
    SharedSelect,
    SharedRadioButton,
    SharedButton,
    ShopSelection,
    SharedStep,
    Loading,
  },
  setup: () => ({ v$: useVuelidate({ $lazy: true }) }),

  data() {
    return {
      form: this.setForm(),
      fields: [],
      displayLoading: false,
      termCheck: true,
      providerOptions: {},
      verificationCode: '',
      counter: 0,
      timer: null,
      codeIsValid: true,
      mobileIsValid: false,
      isMobileValidating: false,
      mobileValidMessage: null,
      codeValidMessage: null,
      validateErrorMessage: "輸入的資料有誤或未填寫，請確認"
    };
  },

  computed: {
    ...mapGetters("liffAuth", ["user"]),
    counterMessage() {
      return this.trans("sms_code_expire_in", "{second} 秒後失效", {
        second: this.counter,
      });
    },
  },

  validations() {
    let form = {};
    let mobileIsValid = {};

    for (let i = 0; i < this.fields.length; i++) {
      let field = this.fields[i];
      // 特殊規則 手機
      if (field.type === "mobile_phone") {
        form.mobile_phone = this.isFieldRequired("mobile_phone")
          ? {
              required,
              mobile: (val) => {
                return /09[0-9]{8}/.test(val);
              },
            }
          : {};

        if (this.getModuleConfig("verify_page.verify_phone")) {
          mobileIsValid = {
            isValid: (val) => {
              return val == true;
            },
          };
        }

        continue;
      }

      // 特殊規則 電子信箱
      if (field.type === "email") {
        form[field.field_key] = {
          ...(field.required && { required }),
          email: (val) => {
            if (!val) {
              return true;
            }

            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
          },
        };

        continue;
      }

      // 特殊規則 日期
      if (field.type === "date") {
        form[`${field.field_key}-year`] =
          field.required === true ? { required } : {};
        form[`${field.field_key}-month`] =
          field.required === true ? { required } : {};
        form[`${field.field_key}-day`] =
          field.required === true ? { required } : {};

        continue;
      }

      // 特殊規則 地址
      if (field.type === "address") {
        form[`${field.field_key}-city`] = this.isFieldRequired("address")
          ? { required }
          : {};
        form[`${field.field_key}-district`] = this.isFieldRequired("address")
          ? { required }
          : {};
        form[`${field.field_key}-address`] = this.isFieldRequired("address")
          ? { required }
          : {};
        continue;
      }

      // 一般欄位規則
      form[field.field_key] = [
        {
          ruleName: 'required',
          enabled: field.required,
          validator: required,
        },
        {
          ruleName: 'regex',
          enabled: !!field.regex,
          validator: helpers.withMessage(
            "格式錯誤",
            (value) => !value || (new RegExp(field.regex, "gu")).test(value)
          ),
        }
      ]
        .filter(rule => rule.enabled)
        .reduce((enabledRules, currentRule) => {
          return { ...enabledRules, [currentRule.ruleName]: currentRule.validator }
        }, {});
    }

    return {
      form,
      mobileIsValid,
    };
  },

  created() {
    this.init();
  },
  watch: {
    "form.mobile_phone"(newValue) {
      this.setSyncedMobilePhone(newValue);
    },
  },

  mounted() {},

  methods: {
    ...mapActions({
      fetchMe: 'liffAuth/fetchMe',
    }),
    isValidJsonArray,
    setForm() {
      //解決動態 validations 必須先定義 form 的 property

      var form = {};
      let fields = this.fetchFields();

      // Refill fields
      fields.forEach((field) => {
        let isExtra = field.matched_key.startsWith("extra.");
        let user = isExtra
          ? this.$store.state.liffAuth.user.extra
          : this.$store.state.liffAuth.user;

        // 特殊規則 地址
        if (field.type === "address") {
          // if (
          //   user[`${field.field_key}-city`] &&
          //   user[`${field.field_key}-city`] !== undefined
          // )
          form[`${field.field_key}-city`] = user[`${field.field_key}-city`];

          // if (
          //   user[`${field.field_key}-district`] &&
          //   user[`${field.field_key}-district`] !== undefined
          // )
          form[`${field.field_key}-district`] =
            user[`${field.field_key}-district`];

          // if (
          //   user[`${field.field_key}-address`] &&
          //   user[`${field.field_key}-address`] !== undefined
          // )
          form[`${field.field_key}-address`] =
            user[`${field.field_key}-address`];

          return;
        }

        // 特殊規則 日期
        if (field.type === "date") {
          const parseDate = new Date(
            this.$route.query[field.matched_key] ||
              field.value ||
              user[field.field_key]
          );

          form[`${field.field_key}-year`] = parseDate.getFullYear();
          form[`${field.field_key}-month`] = parseDate.getMonth() + 1;
          form[`${field.field_key}-day`] = parseDate.getDate();

          return;
        }

        // checkbox
        if (field.type === "checkbox") {
          form[field.field_key] =
            this.$route.query[field.matched_key] ||
            field.value ||
            this.isValidJsonArray(user[field.field_key])
              ? JSON.parse(user[field.field_key])
              : user[field.field_key];

          return;
        }

        // if (user[field.field_key] !== undefined) {
        //其他一般欄位
        form[field.field_key] =
          this.$route.query[field.matched_key] ||
          field.value ||
          user[field.field_key];

        if (field.type === "mobile_phone") {
          form[field.field_key] = this.getSyncedMobilePhone() || form[field.field_key];
        }

        return;
        //}
      });

      return { ...form };
    },
    async init() {
      await this.migrateLegacyMobilePhoneQuery();
      this.fields = this.fetchFields();
      this.fetchProviderFieldsOption();

      //Mobile Valid
      this.mobileIsValid =
        this.getModuleConfig("verify_page.verify_phone") &&
        this.user.phone_verified_at;

      const syncedMobilePhone = this.getSyncedMobilePhone();
      if (syncedMobilePhone && Object.prototype.hasOwnProperty.call(this.form, "mobile_phone")) {
        this.form.mobile_phone = syncedMobilePhone;
      } else if (this.form.mobile_phone) {
        this.setSyncedMobilePhone(this.form.mobile_phone);
      }

      //Refill fields
      this.fields.forEach(async (field) => {
        let isExtra = field.matched_key.startsWith("extra.");
        let user = isExtra ? this.user.extra : this.user;

        // 特殊規則 地址
        if (field.type === "address") {
          // 之所以改到這裡，是為了在初始化 twCitySelector 時直接賦值 city & district
          new TwCitySelector({
            el: ".city-selector-set-has-value",
            elCounty: ".county",
            elDistrict: ".district",
            countyValue: user[`${field.field_key}-city`],
            districtValue: user[`${field.field_key}-district`],
          });

          return;
        }
      });

      if (
        this.getModuleConfig("verify_page.enable_terms_check") &&
        this.getModuleConfig("verify_page.terms_check")
      ) {
        this.termCheck = false;
      }

      if (
        this.getModuleConfig("verify_page.verify_phone") &&
        !this.mobileIsValid &&
        this.form.mobile_phone
      ) {
        await this.resumeVerifyCountdown(this.form.mobile_phone);
      }
    },
    fetchFields() {
      let fields = this.getModuleConfig("verify_page.member_fields");

      fields = _.map(fields, (field) => {
        let field_key;
        if (field.matched_key) {
          field_key = field.matched_key.startsWith("extra.")
            ? field.matched_key.substring(6)
            : field.matched_key;
        } else {
          field_key = field.type;
        }

        return {
          ...field,
          field_key,
        };
      });

      return _.sortBy(fields, "order");
    },
    isFieldShow(key) {
      return this.fields.some((field) => field.type === key);
    },
    isFieldRequired(key) {
      return this.fields.some(
        (field) => field.type === key && field.required == true
      );
    },
    displayPlaceholder(field, defaultMessage = null) {
      if (field.placeholder) return field.placeholder;
      if (defaultMessage) return defaultMessage;
      if (field.title) return "請選擇" + field.title;
      return "";
    },
    displayTitle(field, defaultMessage = null) {
      if (field.title) return field.title;
      if (defaultMessage) return defaultMessage;
      return "";
    },
    async handleSubmit() {
      const result = await this.v$.$validate();
      if (!result) {
        const element = document.getElementById(this.v$.$errors[0].$property);
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }

      if (!this.termCheck) {
        return;
      }

      if (!this.checkMobilePhone()) {
        return;
      }

      try {
        this.displayLoading = true;
        await this.doHandleSubmit();
      } catch (error) {
        console.error("error", error);
      }
      this.displayLoading = false;
    },
    async sendMobilePhoneVerificationCode() {
      await registerApi.onlyVerify({
        mobile_phone: this.form.mobile_phone,
      });
    },
    async doHandleSubmit() {
      // 依照 module_config 中的 member_fields 組裝送到後端的資料
      let payload = { extra: {}, from: 'verify_form' };

      Object.keys(this.$route.query).forEach((key) => {
        if (key.startsWith('extra.')) {
          payload.extra[key.substring(6)] = this.$route.query[key];
        }
      });

      this.fields.forEach((field) => {
        let isExtra = field.matched_key.startsWith("extra.");
        let data = isExtra ? payload.extra : payload;

        //let fieldConfig = this.fields[i];

        // 如果是特殊類型的欄位
        if (field.type === "date") {
          data[field.field_key] = `${this.form[`${field.field_key}-year`]}-${
            this.form[`${field.field_key}-month`]
          }-${this.form[`${field.field_key}-day`]}`;
          return;
        }

        if (field.type === "address") {
          data[`${field.field_key}-city`] =
            this.form[`${field.field_key}-city`];
          data[`${field.field_key}-district`] =
            this.form[`${field.field_key}-district`];
          data[`${field.field_key}-address`] =
            this.form[`${field.field_key}-address`];
          return;
        }

        // // 如果是 extra 欄位
        // if (field.matched_key.startsWith("extra.")) {
        //   let fieldName = field.matched_key.substring(6);
        //   data[fieldName] = this.form[fieldName];
        //   //continue;
        // }

        // 一般欄位就不處理
        data[field.field_key] = this.form[field.field_key];
      });

      let response;
      try {
        response = await registerApi.register(payload);
      } catch (error) {
        const responseData = error.response?.data || {};
        const next = responseData.next;

        if (responseData.code === "EMAIL_ALREADY_USED") {
          this.$swal(responseData.title || this.trans('alert', '提醒'), responseData.message || "", "warning");
          return;
        }

        if (next === "email_verify_page" || this.isEmailOtpAlreadySentError(responseData)) {
          this.setEmailVerifyContext(this.buildEmailVerifyQuery(responseData, {
            email: payload.email,
            from: 'verify_form',
          }));

          this.confirmGoToEmailVerifyPage(responseData);
          return;
        }

        if (responseData?.code === "SMS_OTP_THROTTLED") {
          this.handleOtpAlreadySent(error, 'verify_form');
          return;
        }

        if (next === "verify_page") {
          await this.goNext(next, { from: 'verify_form' });
          return;
        }

        this.$swal(
          responseData.title || this.trans('error', '錯誤'),
          responseData.message || "",
          "error"
        );
        return;
      }

      if (response.data.status === "error" && response.data.next) {
        this.displayLoading = false;
        await this.$swal(
          this.trans('error', '錯誤'),
          response.data.reason || response.data.message || "發生錯誤，請重新確認",
          "error"
        );
        return;
      }

      await this.fetchMe();

      this.setSyncedMobilePhone(this.form.mobile_phone);

      const next = response.data.next ?? "success_page"

      if (next === "email_verify_page") {
        const emailVerifyQuery = this.buildEmailVerifyQuery(response.data, {
          email: payload.email,
          from: 'verify_form',
        });

        this.setEmailVerifyContext(emailVerifyQuery);
        await this.goNext(next, emailVerifyQuery);
        return;
      }

      if (next === "verify_page" && this.isReturnedFromRegisterValidate()) {
        const isSameMobilePhone = this.isSameAsRegisterValidateMobilePhoneSnapshot(this.form.mobile_phone);
        if (!isSameMobilePhone) {
          this.confirmGoToVerifyPage(null, 'verify_form', response.data.phone_verify);
          return;
        }
      }

      this.setRegisterValidateMobilePhoneSnapshot(this.form.mobile_phone);

      if (next === "verify_page") {
        this.goToVerifyPage('verify_form', response.data.phone_verify);
        return;
      }

      await this.goNext(next, { from: 'verify_form' });
    },
    isEmailOtpAlreadySentError(responseData) {
      const message = responseData.message || "";
      const code = responseData.code || "";
      const reason = responseData.reason || "";

      if (code === "EMAIL_ALREADY_USED") {
        return false;
      }

      return code.startsWith("EMAIL_OTP")
        || reason.includes("email")
        || message.includes("Email")
        || message.includes("email");
    },
    confirmGoToEmailVerifyPage(responseData) {
      this.$swal({
        title: this.trans('email_code_sent_title', '驗證碼已發送'),
        html: this.resolveEmailOtpAlreadySentMessage(responseData),
        icon: "warning",
        confirmButtonText: this.trans('go_to_verify', '前往驗證'),
      }).then((result) => {
        if (result.value || result.isConfirmed) {
          this.$router.push({
            name: "LiffRegisterEmailValidate",
            params: {
              orgCode: this.$route.params.orgCode,
            },
            query: this.buildPublicRouteQuery({ from: 'verify_form' }),
          });
        }
      });
    },
    resolveEmailOtpAlreadySentMessage(responseData) {
      if (responseData.message) {
        return responseData.message.replace(/簡訊/g, 'Email');
      }

      const remainingSeconds = this.resolveEmailOtpRemainingSeconds(responseData);

      if (remainingSeconds === null) {
        return this.trans('email_code_sent_message', '稍早已發送驗證碼，請耐心稍候。');
      }

      return this.trans(
        'email_code_sent_with_resend_time',
        '稍早已發送驗證碼，請耐心稍候。<br>若持續未收到，請於 {time} 後重試或檢查Email',
        {
          time: this.formatRemainingSeconds(remainingSeconds),
        }
      );
    },
    resolveEmailOtpRemainingSeconds(responseData) {
      const expiredAt = responseData.expired_at ?? responseData.data?.expired_at;

      if (expiredAt) {
        const now = Math.floor(Date.now() / 1000);
        return Math.max(0, Number(expiredAt) - now + 1);
      }

      return null;
    },
    handleOtpAlreadySent(error, from) {
      const phoneVerify = error?.response?.data?.phone_verify;

      if (!this.isReturnedFromRegisterValidate()) {
        this.goToVerifyPage(from, phoneVerify);
        return;
      }

      // 從 validate 頁回來：若 OTP 已失效，直接跳入驗證頁；否則仍顯示彈窗
      const expiredAt = phoneVerify?.expired_at
        ?? error?.response?.data?.expired_at
        ?? error?.response?.data?.data?.expired_at;
      const now = Math.floor(Date.now() / 1000);
      const isOtpExpired = !expiredAt || expiredAt <= now;

      if (isOtpExpired) {
        this.goToVerifyPage(from, phoneVerify);
        return;
      }

      this.confirmGoToVerifyPage(error, from, phoneVerify);
    },
    confirmGoToVerifyPage(error, from, phoneVerify = null) {
      const isSameMobilePhone = this.isSameAsRegisterValidateMobilePhoneSnapshot(this.form.mobile_phone);

      this.$swal({
        title: '驗證碼已發送',
        html: isSameMobilePhone
          ? this.resolveOtpAlreadySentMessage(error)
          : '因您填寫新的手機號碼，<br>已發送新驗證碼。',
        icon: "warning",
        confirmButtonText: this.trans('go_to_verify', '前往驗證'),
      }).then((result) => {
        if (result.value || result.isConfirmed) {
          this.goToVerifyPage(from, phoneVerify);
        }
      });
    },
    resolveOtpAlreadySentMessage(error) {
      const errorMessage = error?.response?.data?.message || "";
      const expiredAt = error?.response?.data?.expired_at ?? error?.response?.data?.data?.expired_at;
      const remainingSeconds = this.resolveRemainingSeconds(expiredAt, errorMessage);

      if (remainingSeconds === null) {
        if (this.counter > 0) {
          return `我們已發送驗證碼。<br>若未收到，請於 ${this.formatRemainingSeconds(this.counter)} 後再重新發送`;
        }

        return errorMessage || "驗證碼已發送，請稍後再重新嘗試";
      }

      return `我們已發送驗證碼。<br>若未收到，請於 ${this.formatRemainingSeconds(remainingSeconds)} 後再重新發送`;
    },
    resolveRemainingSeconds(expiredAt, errorMessage) {
      if (expiredAt) {
        const now = Math.floor(Date.now() / 1000);
        return Math.max(0, Number(expiredAt) - now + 1);
      }

      const minuteSecondMatch = errorMessage.match(/(\d+)\s*分\s*(\d+)\s*秒/);
      if (minuteSecondMatch) {
        return Number(minuteSecondMatch[1]) * 60 + Number(minuteSecondMatch[2]);
      }

      const secondMatch = errorMessage.match(/(\d+)\s*秒/);
      if (secondMatch) {
        return Number(secondMatch[1]);
      }

      return null;
    },
    formatRemainingSeconds(remainingSeconds) {
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;
      return `${minutes} 分 ${seconds} 秒`;
    },
    goToVerifyPage(from, phoneVerify = null) {
      if (phoneVerify) {
        this.setPhoneVerifyContext(phoneVerify);
      }
      this.setSyncedMobilePhone(this.form.mobile_phone);
      this.setRegisterValidateMobilePhoneSnapshot(this.form.mobile_phone);
      this.$router.push({
        name: "LiffRegisterValidate",
        params: {
          orgCode: this.$route.params.orgCode,
        },
        query: this.sanitizeRegisterQuery({ from }),
      });
    },
    async fetchProviderFieldsOption() {
      this.$nextTick(() => {
        this.fields
          .filter(f => f.provider)
          .map(field => {
            this.$refs[`shop-selection-${field.field_key}`][0].fetchBranchesOptions()
          })
      })
    },
    async sendMobile() {
      try {
        const response = await registerApi.sendPhone(this.form.mobile_phone);
        if (response.data.status === "success") {
          this.mobileValidMessage = null;
          await this.resumeVerifyCountdown(this.form.mobile_phone, true);
        }
      } catch (error) {
        console.log('send sms code error', error);

        const expiredAt = error?.response?.data?.expired_at ?? null;
        if (expiredAt) {
          this.applyExpiredAtCounter(expiredAt);
          this.isMobileValidating = this.counter > 0;
          this.startTimer();
          this.mobileValidMessage = this.trans('sms_code_already_sent', '驗證碼已送出，請使用現有驗證碼。');
          return;
        }

        this.mobileValidMessage = this.trans('sms_send_error', '簡訊驗證發送出現問題');
      }
    },
    async verifyMobile() {
      await registerApi
        .verifyByMobile(this.verificationCode, this.form.mobile_phone)
        .then((response) => {
          if (response.data.status == "success") {
            this.fetchMe();

            this.codeIsValid = this.mobileIsValid = true;
            this.isMobileValidating = false;
            this.codeValidMessage = null;
          }
        })
        .catch((error) => {
          this.codeIsValid = this.mobileIsValid = false;
          this.errorCode = error.response.data?.code;
          this.codeValidMessage = this.errorCode === 4001
            ? this.trans('wrong_sms_code', '驗證碼輸入錯誤')
            : error.response.data.message;
        });

      //this.mobileIsValid = false;
    },

    async resumeVerifyCountdown(mobilePhone, fallbackToDefaultTtl = false) {
      const hasCounter = await this.initVerifyCodeCounter(mobilePhone);
      if (!hasCounter && fallbackToDefaultTtl) {
        this.counter = this.getVerifyMobileTtl();
      }

      this.isMobileValidating = this.counter > 0;
      this.startTimer();
    },
    getVerifyMobileTtl() {
      return this.getMobileVerifyRetryGapSeconds(TIMEOUT);
    },
    applyExpiredAtCounter(expiredAt) {
      if (!expiredAt) {
        this.counter = 0;
        return false;
      }

      const now = Math.floor(Date.now() / 1000);
      this.counter = Math.max(0, Number(expiredAt) - now + 1);
      return this.counter > 0;
    },
    async initVerifyCodeCounter(mobilePhone) {
      try {
        const response = await registerApi.getVerifyCodeExpiredTime(mobilePhone);
        return this.applyExpiredAtCounter(response?.data?.expired_at ?? null);
      } catch (error) {
        this.counter = 0;
        return false;
      }
    },
    startTimer() {
      this.clearTimer();

      if (this.counter <= 0) {
        this.isMobileValidating = false;
        return;
      }

      this.timer = window.setInterval(() => {
        this.counter--;

        if (this.counter > 0) {
          return;
        }

        this.clearTimer();
      }, 1000);
    },
    clearTimer() {
      if (!this.timer) {
        return;
      }

      window.clearInterval(this.timer);
      this.timer = null;
    },
    // 檢查手機號碼格式
    checkMobilePhone() {
      // 如果沒有設定手機號碼 直接過
      if (!this.fields.find((f) => f.matched_key == "mobile_phone")) {
        return true;
      }
      let phone = this.form.mobile_phone;
      let formattedPhone = phone;
      const alertTitle = this.trans('alert', '提醒')
      const alertMessage = this.trans('error_phone_format', '手機格式錯誤')

      // 長度大於 10 碼的處理
      if (phone.length > 10) {
        if (phone.startsWith("+886")) {
          // 如果 +886 後面接 09，一樣把 +886 去除後，補回 09
          formattedPhone = phone.startsWith("+88609")
            ? phone.substring(4)
            : "0" + phone.substring(4);
        } else if (phone.startsWith("886")) {
          // 如果 886 後面接 09，一樣把 886 去除後，補回 09
          formattedPhone = phone.startsWith("88609")
            ? phone.substring(3)
            : "0" + phone.substring(3);
        } else if (phone.startsWith("+")) {
          formattedPhone = phone.substring(1);
        } else {
          this.$swal(alertTitle, alertMessage, "warning");
          return false;
        }
      }

      // 根據長度進行不同的處理
      switch (formattedPhone.length) {
        case 10:
          // 檢查是否以 "09" 開頭
          if (!formattedPhone.startsWith("09")) {
            this.$swal(alertTitle, alertMessage, "warning");
            return false;
          }
          // 是否全部都數字
          if (!/^\d+$/.test(formattedPhone)) {
            this.$swal(alertTitle, alertMessage, "warning");
            return false;
          }
          break;
        case 9:
          // 檢查是否以 "9" 開頭並補 "0"
          if (formattedPhone.startsWith("9")) {
            formattedPhone = "0" + formattedPhone;
          } else {
            this.$swal(alertTitle, alertMessage, "warning");
            return false;
          }
          // 是否全部都數字
          if (!/^\d+$/.test(formattedPhone)) {
            this.$swal(alertTitle, alertMessage, "warning");
            return false;
          }

          break;
        default:
          // 長度不符合條件
          this.$swal(alertTitle, alertMessage, "warning");
          return false;
      }

      // 更新手機號碼並繼續後續處理
      this.form.mobile_phone = formattedPhone;
      this.setSyncedMobilePhone(formattedPhone);

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/shared/components/_fields.scss';

.form {
  padding: 0 5px;
  &__error-msg {
    color: #fe0000;
    font-size: 12px;
    margin-top: 8px;
  }
}

.reminder {
  font-size: 12px;
  color: var(--liff-secondary_text_color);
  margin: 12px;
  a {
    text-decoration: underline;
  }
}

.terms_check {
  color: var(--liff-primary_text_color);
  margin: 12px;
  font-size: 16px;
  ::v-deep a {
    text-decoration: underline;
    color: var(--s-primary);
  }
}

.code-input {
  margin-bottom: 32px;
  ::v-deep .react-code-input-container {
    margin: auto;
    text-align: center;
    width: auto !important;
    &.invalid input {
      border: 1px solid #fe0000;
    }
  }
  ::v-deep input {
    border: 1px solid #636366 !important;
    border-radius: 10px !important;
    font-size: 18px;
    font-weight: 600;
    width: 100% !important;
    font-family: PingFang TC;
    color: var(--primary-color) !important;

    &:not(:last-of-type) {
      margin-right: 8px;
    }

    &:focus {
      border: 1px solid var(--liff-primary_text_color);
      caret-color: var(--liff-primary_text_color);
    }
    &:focus + input {
      border: 1px solid #636366;
    }
  }
}
</style>
